export const ORIGIN_LIST = [
  {
    name: '西宁草莓',
    baseUrl: '/xiningcaomei',
    target: 'http://xncm.idx365.com',
    type: '3.0',
    accessKey: "e7f2c59f6d4a4b108321f954a4d632e8",
    secretKey: "1b8d3f4c7e2946da9bf573e1c0f2a8b4",
  },
  {
    name: '3.0',
    baseUrl: '/idx3',
    target: 'http://slkjzsv3.0.idx365.com',
    type: '3.0',
    accessKey: "e7f2c59f6d4a4b108321f954a4d632e8",
    secretKey: "1b8d3f4c7e2946da9bf573e1c0f2a8b4"
  },
  {
    name: "南大堡",
    type: 'nandabao'
  }
]